import { ReactElement } from "react";
import { Container } from "./style";

interface IAppContainerProps {
  children: ReactElement;
  hideLastCol?: boolean;
}

function AppContainer({ children, hideLastCol }: IAppContainerProps) {
  return <Container hideLastCol={hideLastCol}>{children}</Container>;
}

export default AppContainer;
